import {
  IDerapiIntervalsQuery,
  IDerapiJoinFormRequest,
  IDerapiJoinFormResponse,
  IDerapiSiteIntervalsResponse,
  IDerapiSolarInverterIntervalsResponse,
} from "../contracts/Derapi";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { getDataAsync, postDataAsync } from "../ZeosApiExecutor";
import { IDerapi } from "./interfaces/IDerapi";

const API_BASE_URL = `/Rockcity`;
const JOIN_API_BASE_URL = `/Derapi`;

const buildQueryString = (query: IDerapiIntervalsQuery): string => {
  const params = new URLSearchParams();
  if (query.propertyId !== undefined && query.propertyId !== null) {
    params.set("propertyId", query.propertyId.toString());
  }
  if (query.siteId) {
    params.set("siteId", query.siteId);
  }
  if (query.inverterId) {
    params.set("inverterId", query.inverterId);
  }
  if (query.summaryLevel) {
    params.set("summaryLevel", query.summaryLevel);
  }
  if (query.start) {
    params.set("start", query.start);
  }
  if (query.end) {
    params.set("end", query.end);
  }
  if (query.missing) {
    params.set("missing", query.missing);
  }
  const queryString = params.toString();
  return queryString ? `?${queryString}` : "";
};

export const Derapi: IDerapi = {
  getRockcitySiteIntervals: async (
    query: IDerapiIntervalsQuery
  ): Promise<IZeosApiResponse<IDerapiSiteIntervalsResponse>> => {
    const queryString = buildQueryString(query);
    return await getDataAsync<IDerapiSiteIntervalsResponse>(
      `${API_BASE_URL}/SiteIntervals${queryString}`,
      ""
    );
  },
  getRockcityInverterIntervals: async (
    query: IDerapiIntervalsQuery
  ): Promise<IZeosApiResponse<IDerapiSolarInverterIntervalsResponse[]>> => {
    const queryString = buildQueryString(query);
    return await getDataAsync<IDerapiSolarInverterIntervalsResponse[]>(
      `${API_BASE_URL}/InverterIntervals${queryString}`,
      ""
    );
  },
  createJoinForm: async (
    request: IDerapiJoinFormRequest
  ): Promise<IZeosApiResponse<IDerapiJoinFormResponse>> => {
    return await postDataAsync<IDerapiJoinFormResponse>(
      `${JOIN_API_BASE_URL}/join-form`,
      request
    );
  },
};
